/**
 * Shared copy for the reports feature to avoid repetition and keep wording consistent.
 */

// ——— Page ———
export const REPORTS_PAGE_INTRO = "Genera el informe de gestión (PDF) o reportes de bañistas y novedades (Excel o PDF).";

/** Global note shown once at the top (same style as per-card notes). */
export const REPORTS_PAGE_GLOBAL_NOTE =
  "El rango de fechas es de máximo 32 días y los archivos se descargan automáticamente. Elige el tipo de reporte y las opciones en cada sección.";

// ——— Common form labels & hints ———
export const LABEL_DATE_RANGE = "Rango de fechas";
export const LABEL_BUILDING_OPTIONAL = "Unidad Residencial (opcional)";
export const LABEL_BUILDING_REQUIRED = "Unidad Residencial";
export const LABEL_FORMAT = "Formato";

export const OPTION_ALL_BUILDINGS = "Todas las unidades residenciales";
export const PLACEHOLDER_SELECT_DATES_FIRST = "Selecciona primero las fechas";
export const PLACEHOLDER_SEARCH_BUILDING = "Buscar unidad residencial...";
export const PLACEHOLDER_LOADING_BUILDINGS = "Cargando unidades...";

export const HINT_SELECT_DATES_FIRST = "Primero selecciona ambas fechas";
export const LOADING_BUILDINGS = "Cargando unidades residenciales...";

export const FORMAT_EXCEL = "Excel (.xlsx)";
export const FORMAT_PDF = "PDF (.pdf)";

export const BUTTON_GENERATING = "Generando...";
export const BUTTON_GENERATE_REPORT = "Generar Reporte";
export const BUTTON_GENERATE_INFORM = "Generar Informe";

export const NOTE_LABEL = "Nota";

// ——— Empty states ———
export const NO_BUILDINGS_AVAILABLE = "No hay unidades residenciales disponibles";
export const NO_BUILDINGS_WITH_SWIMMERS_IN_RANGE =
  "No hay unidades residenciales con bañistas en este rango de fechas";
export const NO_BUILDINGS_WITH_NEWS_IN_RANGE =
  "No hay unidades residenciales con novedades en este rango de fechas";

// ——— Report-specific notes (short; common rules are in REPORTS_PAGE_INTRO) ———
export const MANAGEMENT_NOTE =
  "PDF por unidad residencial. Opción de incluir resumen anual con gráficas por mes.";

/** TODO: Remove once legacy report is retired and this becomes the default. */
export const MANAGEMENT_NEW_NOTE =
  "Nueva versión del informe de gestión. PDF con análisis de riesgo detallado, tablas dinámicas y páginas de interpretación. Opción de incluir resumen anual.";

/** Short note for Excel/PDF reports. Subject: "bañistas" or "novedades" (article matches: los/las). */
export function getExcelPdfReportNote(subject: "bañistas" | "novedades"): string {
  const article = subject === "bañistas" ? "los" : "las";
  return `Incluye todos ${article} ${subject} del rango. Filtro opcional por unidad residencial. Formatos: Excel o PDF.`;
}

export const CHECKBOX_INCLUDE_YEAR_SUMMARY = "Incluir resumen anual (gráficas por mes)";
